import { undoItem, redoItem } from 'prosemirror-menu';
export function insertVariable(variable) {
  return function (state, dispatch) {
    const type = state.schema.nodes[variable];
    const {
      $from
    } = state.selection;
    if (!$from.parent.canReplaceWith($from.index(), $from.index(), type)) return false;
    if (dispatch) {
      dispatch(state.tr.replaceSelectionWith(type.create()));
    }
    return true;
  };
}
export function insertPillbox(label, token) {
  return function (state, dispatch) {
    const type = state.schema.nodes.pillbox;
    const {
      $from
    } = state.selection;
    if (!$from.parent.canReplaceWith($from.index(), $from.index(), type)) return false;
    if (dispatch) {
      dispatch(state.tr.replaceSelectionWith(type.create({
        label,
        token
      })));
    }
    return true;
  };
}
export function markActive(state, type) {
  const {
    from,
    $from,
    to,
    empty
  } = state.selection;
  if (empty) {
    return type.isInSet(state.storedMarks || $from.marks());
  } else {
    return state.doc.rangeHasMark(from, to, type);
  }
}
export const MenuItemEnum = {
  ToggleStrong: 'toggleStrong',
  ToggleEm: 'toggleEm',
  ToggleLink: 'toggleLink',
  InsertImage: 'insertImage',
  WrapBulletList: 'wrapBulletList',
  WrapOrderedList: 'wrapOrderedList',
  WrapBlockQuote: 'wrapBlockQuote',
  TextTypeMenu: 'textTypeMenu',
  HistoryMenu: 'historyMenu',
  VariablesMenu: 'variablesMenu',
  ExtensionsMenu: 'extensionsMenu',
  All: 'all'
};
const requiredMenuItems = [MenuItemEnum.VariablesMenu];

// Determines what menu items are rendered in the menubar
// Variables are required items that if @variables are present, the dropdown menu will always be present
export function menuBarBuilder(menuItems, excludeMenuItems) {
  const menuItemSets = [[MenuItemEnum.VariablesMenu], [MenuItemEnum.ToggleStrong, MenuItemEnum.ToggleEm, MenuItemEnum.ToggleLink, MenuItemEnum.InsertImage], [MenuItemEnum.WrapBulletList, MenuItemEnum.WrapOrderedList, MenuItemEnum.WrapBlockQuote], [MenuItemEnum.TextTypeMenu], [MenuItemEnum.ExtensionsMenu]];
  const excludeAll = excludeMenuItems.includes(MenuItemEnum.All);
  let activeMenuItems = menuItemSets.reduce((sets, set) => {
    const filteredSet = set.reject(i => {
      const excludeAllButRequired = excludeAll && !requiredMenuItems.includes(i);
      return excludeMenuItems.includes(i) || excludeAllButRequired;
    });
    if (filteredSet.length > 0) {
      sets.push(filteredSet.map(i => menuItems[i]).compact());
    }
    return sets;
  }, []);
  if (!excludeMenuItems.includes(MenuItemEnum.HistoryMenu) && !excludeAll) {
    activeMenuItems = activeMenuItems.concat([[undoItem, redoItem]]);
  }
  return activeMenuItems;
}